<template>
  <div>
    <div class="launch-content" v-show="isShowList">
      <Ad  activeType="adServingManage">
        <span slot="adServingManage">
          <List @create="handleCreate" @edit="handleEdit" @lockPreviousStep="handleLockPreviousStep" @read="handleRead" ref="list" />
        </span>
      </Ad>
    </div>
    <div v-if="!isShowList && mode !== 'read'">
      <Add :id="id" :mode="mode" :prevOrder="prevOrder" :prevSchedule="prevSchedule" @open-list="openListPage" @go-back="handleGoBack"></Add>
    </div>
  </div>
</template>
<script>
import Ad from '@/components/Ad'
import List from './AdServingManageList'
import Add from './AdServingManageAdd'
// import Read from './AdServingManageRead'
export default {
  components: {
    Ad,
    List,
    Add
    // Read
  },
  data() {
    return {
      isShowList: true,
      id: undefined,
      mode: 'create',
      previousStepForm: undefined,
      prevOrder: {},
      prevSchedule: {}
    }
  },
  props: ['add'],
  methods: {
    // quickSearch(){
    //   this.$refs.list.fetchDataDebounced()
    // },
    handleCreate() {
      this.isShowList = false
      this.mode = 'create'
      this.id = undefined
    },
    handleEdit(item) {
      this.id = item.scheduleId
      this.mode = 'edit'
      this.isShowList = false
    },
    handleLockPreviousStep() {
      this.mode = 'edit'
      this.isShowList = false
      this.prevOrder = this.$route.params.order
      this.prevSchedule = this.$route.params.scheduleForm
    },
    handleRead(item) {
      this.id = item.scheduleId
      this.mode = 'read'
      this.isShowList = false
    },
    openListPage() {
      this.isShowList = true
      this.$refs.list.fetchData()
    },
    handleGoBack(item) {
      this.isShowList = true
      this.mode = 'list'
      this.$nextTick(() => {
        this.$refs.list.fetchData()
      })
    }
  },
  created() {
    if (this.add) {
      this.handleCreate()
    }
    if (this.$route.params.previousStep) {
      this.handleLockPreviousStep()
    }
  }
}
</script>
<style lang="stylus" scoped>
// >>> .el-button
//     padding-top 0px
//     padding-bottom 0px
//     line-height 34px
//     height 34px
</style>
